import { APIClient } from '@frontend/api-utils';
import { IoTStateName, IoTTriggerName, PostTrigger } from '@frontend/iot/types';

export class IoTWorkflowClient extends APIClient {
    public static readonly endpoint = '/iot-api/v1';

    public static async updateIoTState(accountId: string, iotId: string, state: IoTStateName): Promise<void> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/change-state`, { state: state });
        return await this.handleVoidResponse(response);
    }

    public static async postIoTTrigger(accountId: string, iotId: string, trigger: PostTrigger<IoTTriggerName>): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/trigger`, trigger);
        return await this.handleVoidResponse(response);
    }
}
